import React, { useState } from 'react';
import { Button, Form, ListGroup, Modal } from 'react-bootstrap';
import { Typeahead } from "react-bootstrap-typeahead";
import { FormattedMessage, useIntl } from 'react-intl';
import { ICompany, IUserProfile } from '../util/DataModelInterface';

export interface ISearchModalProps {
  active: boolean;
  searchData: any[];
  modalId: string;
  onSelect: (list: any[]) => void;
  onClose: () => void;
  title: string;
  findText: string;
  placeHolder: string;
  foundItemsTitle: string;
  filterByFields?: string[];
}

export const SearchModal  = (props: ISearchModalProps) => {
  const [singleSelections, setSingleSelections] = useState([] as any[]);
  const [selections, setSelections] = useState([] as any[]);
  const intl = useIntl();

  const isComp = (value: any): value is ICompany => !!value?.business_id;

  const addItem = (sel: ICompany[] | IUserProfile[]) => {
    let selItem = sel[0] as any;
    console.log("adding", selItem);
    let id = isComp(selItem) ? 'business_id' : 'user_id';
    if (selItem && !selections.find((s) => s[id] === selItem[id])) setSelections([...selections, selItem]);
    // Clear input field after selection
    setSingleSelections([] as any[]);
  }

  const removeItem = (item: any) => {
    console.log("removing", item);
    let id = isComp(item) ? 'business_id' : 'user_id';
    let newSelections = selections.filter((s) => s[id] !== item[id]);
    setSelections(newSelections);
  }

  const handleClose = () => {
    props.onClose();
    setSelections([] as any[]);
  }

  const handleSelect = () => {
    props.onSelect(selections);
    handleClose();
  }

  const getSelectionListItem = (item: any, ind: number) => {
    return (
        <ListGroup.Item key={ind} className="d-flex flex-row align-items-center">
          <div className="company">
            <span className="title">
              { item.name }
            </span>
          </div>
          <button className="btn btn-link p-0 my-0 ms-auto" onClick={() => removeItem(item)}>
            <i className="me-2 fa fa-trash"></i>
            <FormattedMessage id="button.remove"/>
          </button>
        </ListGroup.Item>
      );
    }

  return (
    <>
      <Modal id={props.modalId} show={props.active} onHide={handleClose}>

      <Modal.Header>
        <h2>{props.title}</h2>
        <button type="button" className="btn btn-link p-3" onClick={handleClose} aria-label={ intl.formatMessage({ id: 'button.close' })}>
          <i aria-hidden="true" role="presentation" className="fa fa-remove"></i>
        </button>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label className="form-label">{props.findText}</Form.Label>
          <Typeahead
            id="typeahead-search"
            inputProps={{
              'aria-label': props.findText,
            }}
            clearButton
            filterBy={props.filterByFields}
            labelKey="name"
            onChange={(sel) => {addItem(sel as ICompany[] | IUserProfile[]);}}
            options={props.searchData}
            placeholder={props.placeHolder}
            selected={singleSelections}
            renderMenuItemChildren={(option) => {
              let item = option as ICompany | IUserProfile;
              let archived = item.archived;
              let name = item.name;
              let detail = (item as IUserProfile).user_id ? (item as IUserProfile).user_name : (item as ICompany).business_id;
              return (
              <div>
                {!archived && name }
                {archived && <i>{name} <i></i>{archived ? "- " + intl.formatMessage({id: 'companies.archived'}) : null}</i>}
                {detail &&
                  <div>
                      <small>{detail}</small>
                  </div>
                }
              </div>
            )}}
          />
        </Form.Group>
        {selections.length > 0 &&
          <div id="additems-results" className="p-0 mt-3 add-results">
            <span className="form-label">{props.foundItemsTitle}</span>
            {selections.map( (s: any, ind: number) =>
              getSelectionListItem(s, ind)
            )}
          </div>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={handleClose}>
          <FormattedMessage id="button.close"/>
        </Button>
        <Button className="btn btn-primary" onClick={handleSelect}>
          <FormattedMessage id="button.add"/>
        </Button>
      </Modal.Footer>
      </Modal>

    </>
  );
}
